<template>
  <div class="card hoverable minHeight shadow-sm h-100" @click="action">
    <div class="card-header text-start fw-bold">
      {{name}}
    </div>
    <div class="card-body">
      <p class="card-text text-start">{{ description }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String, 
    description: String
  },
  methods: {
    action() {
      this.$emit('action')
    }
  },
}
</script>
<style>
.hoverable:hover {
  cursor: pointer;
  opacity: .7;
}

@media (max-width: 300px) {
  .minHeight {
    min-height: 195px;
  }
}

@media (min-width: 301px) {
  .minHeight {
    min-height: 100px;
  }
}
</style>